import Swiper, { Pagination } from 'swiper';

const SingleCategory = function () {
//   configure Swiper to use modules
  Swiper.use( Pagination );
  const els = document.querySelectorAll( '.swiper-single-category' );

  // loop through swiper sections and init Swiper
  if ( Object.keys(els).length ) {
    els.forEach( function( el ){
      const pagination = el.querySelector( '.swiper-pagination');
      const swiper = new Swiper( el , {
        direction: 'horizontal',
        spaceBetween: 15,
        slidesPerView: 1,
        centeredSlides: true,
        initialSlide: 0,
        loop: false,
        preventClicks: true,
        pagination: {
          el: pagination,
          clickable: true
        },
        breakpoints: {
          992: {
            slidesPerView: 'auto',
            centeredSlides: false,
            pagination: false
          }
        }
      })
    });
  } 

  let typeLinks = document.querySelectorAll('.type-wrap__link');

  let styleImage = document.querySelector('.style-image');
  // let originalSrc = styleImage.getAttribute('src');
  typeLinks.forEach(link => {
    link.addEventListener('mouseenter', (event) => {
        let handle = link.getAttribute('data-handle');
        let srcImage = document.querySelector('.link-image[data-handle="' + handle + '"]')
        styleImage.setAttribute('src', srcImage.getAttribute('src'));
    });
    // link.addEventListener('mouseleave', (event) => {
    //     styleImage.setAttribute('src', originalSrc);
    // });
  });
}

export default SingleCategory;